//
// Generated class EventPhaseSection
//

/// <reference path="EventPhaseSection_ManagedObject.ts" />

class EventPhaseSection extends EventPhaseSection_ManagedObject
{

}
